export default __webpack_public_path__ + "static/media/iphone-sonos.8e93178d.png";